import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDiv = styled.div`
  font-family: 'Backpack', sans-serif;
  font-size: 14px;
  line-height: 17px;
  color: #17181a;
`;

export const Div = ({ element, attributes, children, className }) => (
  <StyledDiv
    {...attributes}
    className={className}
    style={element.style}
    customAttr={element.customAttr}
  >
    {children}
  </StyledDiv>
);

Div.propTypes = {
  children: PropTypes.node,
  attributes: PropTypes.elementType,
  style: PropTypes.object,
  className: PropTypes.string,
  element: PropTypes.shape({
    style: PropTypes.string.isRequired,
  }).isRequired,
};

Div.defaultProps = {
  children: null,
  attributes: [],
  style: {},
  className: '',
};

const defaultDiv = {
  div: {
    component: Div,
    type: 'div',
    rootProps: {
      className: 'slate-div',
    },
  },
};

export default defaultDiv;
